/* eslint-disable react/prop-types */
import { useStore } from '@mirai/data-sources';
import { Action, Input, Text, View } from '@mirai/ui';
import React from 'react';
import { useLocation } from 'wouter';

import * as style from './App.module.css';

export const Container = ({ children }) => {
  const [location, setLocation] = useLocation();

  const {
    value: { session },
  } = useStore();

  const richTemplate = !location.includes('/step');

  return (
    <>
      {richTemplate && (
        <View tag="header" className={style.header}>
          <View row className={[style.wrapper, style.environment]}>
            <Text small className={[style.contact, style.hideMobile]}>
              Contact us directly at +34 (0) 129 039 193
            </Text>
            <View data-mirai-component="environment" data-locale="true" data-currencies="true" data-state="true" />
          </View>

          <View row className={[style.wrapper, style.main]}>
            <View row>
              <Action onPress={() => setLocation('/')}>
                <Text>Home</Text>
              </Action>

              <Action className={style.hideMobile} onPress={() => setLocation('/about-us')}>
                <Text>About Us</Text>
              </Action>

              <Action className={style.hideMobile} onPress={() => setLocation('/rooms')}>
                <Text>Our Rooms</Text>
              </Action>
            </View>

            <View>
              <Action inline onPress={() => setLocation('/')}>
                <Text bold brand headline level={1}>
                  Monalisa
                </Text>
              </Action>
              <Text small>HOTEL & RESORT</Text>
            </View>

            <View row>
              <View data-mirai-component="session" />

              {!session && (
                <Action className={style.hideMobile} onPress={() => setLocation('/signup')}>
                  <Text medium>Signup</Text>
                </Action>
              )}
            </View>
          </View>
        </View>
      )}

      <View tag="main" className={style.children}>
        {children}
      </View>

      {richTemplate && (
        <View tag="footer" className={style.footer}>
          <View row className={[style.wrapper, style.links]}>
            <View>
              <Text bold>Site map</Text>
              <Action inline small onPress={() => setLocation('/')}>
                Home
              </Action>
              <Action inline small onPress={() => setLocation('/signup')}>
                Signup
              </Action>
              <Action inline small onPress={() => setLocation('/profile')}>
                Profile
              </Action>
              <Action inline small onPress={() => setLocation('/deals')}>
                Deals
              </Action>
              <Action inline small onPress={() => setLocation('/rooms')}>
                Rooms
              </Action>
              <Action inline small onPress={() => setLocation('/finder')}>
                Finder
              </Action>
            </View>

            <View>
              <Text bold>Reservation</Text>
              <Action inline small onPress={() => setLocation('/step1-rates')}>
                1. rates
              </Action>
              <Action inline small onPress={() => setLocation('/step2-checkout')}>
                2. checkout
              </Action>
              <Action inline small onPress={() => setLocation('/step3-booking')}>
                3. booking
              </Action>
            </View>

            <View>
              <Text bold>More</Text>
              <View
                data-mirai-component="bookingQuery"
                data-test-id={window.IS_PLAYWRIGHT ? 'bookingQuery' : undefined}
              >
                <Action inline small data-ghost>
                  My Booking
                </Action>
              </View>
              <Action inline small onPress={() => setLocation('/legal-advice')}>
                Legal Advice
              </Action>
              <Action inline small onPress={() => setLocation('/cookie-policy')}>
                Cookie Policy
              </Action>
              <Action inline small onPress={() => setLocation('/privacy-policy')}>
                Privacy Policy
              </Action>
              <Action inline small onPress={() => setLocation('/complaints-channel')}>
                Complaints Channel
              </Action>
            </View>

            <View className={[style.newsletter, style.hideMobile]}>
              <Text bold>Sign up for get our newsletter</Text>
              <Input name="newsletter" placeholder="Your email..." />
            </View>
          </View>

          <Text small className={[style.wrapper, style.copyright]}>
            <Text bold brand headline level={2}>
              Monalisa
            </Text>{' '}
            © 1980-2024 Monalisa Hotel Group Santa Engracia 120. 28003 Madrid, Spain
          </Text>
        </View>
      )}
    </>
  );
};
